<div>
  @if (showAddButton) {
    <button class="filled-button short-button button-md add-payment-socialMedia" (click)="openAddContent()">
      <mat-icon class="mr-10px mat-icon-admin-add-button">add</mat-icon>
      Create New Content
    </button>
  }
  <div class="content-container" [ngClass]="{'background-white': content.length > 0}">
    @if (!showGridList) {
      <div class="pt-85">
        @for (contentType of contentTypesList; track contentType) {
          <ng-container>
            <app-content-list
              [contentType]="contentType.type"
              [contentList]="contentType.content"
              [showMore]="contentType.showMore">
            </app-content-list>
          </ng-container>
        }
      </div>
    }
  </div>
</div>
